export default __webpack_public_path__ + "static/media/karyali3.2f394e79.jpg";